import React from 'react'
import TypeOfModalBadge2023 from '../../../StudentOnboardingCardModalFall2023/ModalAreaFall2023/TypeOfModalBadge2023/TypeOfModalBadge2023';
import ModalDropdownMenuFall2023 from "../../../StudentOnboardingCardModalFall2023/ModalAreaFall2023/ModalDropdownMenuFall2023/ModalDropdownMenuFall2023";
import DropdownWithImage from '../../../DanitComponents/Dropdown/DropdownWithImage/DropdownWithImage';
import Subtask2023 from '../../../TaskCardModal2023/Subtask2023/Subtask2023';
import { PrimaryButtonLarge } from '../../../DanitComponents/Buttons/PrimaryButton';
import { ButtonWithTrailingIconXLarge } from '../../../DanitComponents/Buttons/ButtonWithTrailingIcon';

import { modalOwnerOptions, modalSchoolOptions } from '../../../StudentOnboardingFall2023/student-onboarding-fall-2023-info';
import { freshSubtask } from '../../../AdminTasks/adminTaskUtils';
import { BsThreeDotsVertical } from "react-icons/bs";
import axios from 'axios';
import { baseUrl } from '../../../assets/Animations';
import { getRequestHeaders } from '../../../api';
import WarningPopup from '../../../DanitComponents/Modals/WarningPopup/WarningPopup';

const ApplicationModalArea2024 = ({workflow, setOpenWorkflowModal2024, updateItem, deleteItem, setCongratsModal}) => {
    const [warningPopup, setWarningPopup] = React.useState(false)
    
    const cardLayout = {
        interviewing:{
            type: 'interviewing',
            adminAssignable: true,
            schoolAssignable: true,
            dropDownMenuOptions: [
                {
                    label: 'Move to Waitlist (no email)',
                    onClick: () => moveWorkflowWithNoEmail('waitlist')
                },
                {
                    label: 'Move to Onboard (no email)',
                    onClick: () => moveWorkflowWithNoEmail('onboarding')
                },
                {
                    label: 'Delete Workflow',
                    onClick: () => deleteWorkflowWarning()
                },
            ],
            showCheckList: true,
            addTaskButton: true,
            moveForwardButton: {
                label: 'Onboard',
                onClick: () => moveWorkflowWithNoEmail('onboarding')
            },
            redButton: {
                label: 'Delete Workflow',
                onClick: () => deleteWorkflowWarning()
            },
            neutralButton: {
                label: 'Move to Waitlist',
                onClick: () => moveWorkflowWithNoEmail('waitlist')
            },
        },
        onboarding: {
            type: 'onboarding',
            adminAssignable: true,
            schoolAssignable: true,
            dropDownMenuOptions: [
                {
                    label: 'Move to Waitlist (no email)',
                    onClick: () => moveWorkflowWithNoEmail('waitlist')
                },
                {
                    label: 'Move to Interview (no email)',
                    onClick: () => moveWorkflowWithNoEmail('interviewing')
                },
                {
                    label: 'Delete Workflow',
                    onClick: () => deleteWorkflowWarning()
                },
            ],
            showCheckList: true,
            addTaskButton: true,
            moveForwardButton: {
                label: 'Complete Onboarding',
                onClick: () => completeOnboardingWarning()
            },
            redButton: {
                label: 'Move to Waitlist',
                onClick: () => moveWorkflowWithNoEmail('waitlist')
            },
            neutralButton: {
                label: 'Cancel Onboarding',
                onClick: () => deleteWorkflowWarning()
            },
        },
        offboarding: {
            type: 'offboarding',
            adminAssignable: true,
            schoolAssignable: true,
            dropDownMenuOptions: [],
            showCheckList: true,
            addTaskButton: true,
            moveForwardButton: {
                label: 'Complete Offboarding',
                onClick: () => completeOffboardingWarning()
            },
            redButton: {
                label: 'Delete Workflow',
                onClick: () => deleteWorkflowWarning()
            },
        },
        waitlist: {
            type: 'waitlist',
            adminAssignable: false,
            schoolAssignable: true,
            dropDownMenuOptions: [],
            showCheckList: false,
            showMessageInsteadOfChecklist: 'Click the "To Interviewing" button to move this family to the interviewing workflow and off the waitlist.',
            addTaskButton: false,
            moveForwardButton: {
                label: 'To Interviewing',
                onClick: () => moveWorkflowWithNoEmail('interviewing')
            },
        },
    }

    const [openDropdown, setOpenDropdown] = React.useState(false)

    const completeOnboarding = () => {
        axios.delete(`${baseUrl}/process-teacher-workflow/${workflow.todoId}`, getRequestHeaders())
        .then((res) => {
            deleteItem(res.data, 'todoId')
            setCongratsModal(true)
            setOpenWorkflowModal2024(false)
        })
        .catch((err) => console.log(err.response.data))
    }


    const moveWorkflowWithNoEmail = (column) => {
        axios.post(`${baseUrl}/process-teacher-workflow/${column}/${workflow.todoId}`, {workflow}, getRequestHeaders())
        .then((res) => {
            updateItem(res.data, 'todoId')
            setOpenWorkflowModal2024(false)
        })
        .catch((err) => console.log(err.response.data)) 
    }

    const deleteWorkflow = () => {
        axios.delete(`${baseUrl}/process-teacher-workflow/${workflow.todoId}`, getRequestHeaders())
        .then((res) => {
            deleteItem(res.data, 'todoId')
            setWarningPopup(false)
            setOpenWorkflowModal2024(false)

        })
        .catch((err) => console.log(err))
    }

    const completeOnboardingWarning = () => {
        setWarningPopup({
            type: 'confirm',
            title: 'Are you sure you\'re done onboarding?',
            message: 'If completed, this workflow will be removed from the onboarding page. This cannot be undone. No auto-email will be sent.',
            onCancel: {
                text: 'Go back',
                action: () => setWarningPopup(false)
            },
            onConfirm: {
                text: 'Yes, Complete Onboarding',
                action: () => completeOnboarding()
            } 
        })
    }

    const completeOffboardingWarning = () => {
        setWarningPopup({
            type: 'confirm',
            title: 'Are you sure you have completed offboarding this teacher?',
            message: 'If completed, this workflow will be removed from the onboarding page. This cannot be undone. No auto-email will be sent.',
            onCancel: {
                text: 'Go back',
                action: () => setWarningPopup(false)
            },
            onConfirm: {
                text: 'Yes, Complete Offboarding',
                action: () => deleteWorkflow()
            } 
        })
    }

    const deleteWorkflowWarning = () => {
        setWarningPopup({
            type: 'warning',
            title: 'Are you sure you want to delete this workflow?',
            message: 'If deleted, this workflow will be removed from the onboarding page. This cannot be undone. No auto-email will be sent.',
            onCancel: {
                text: 'Go back',
                action: () => setWarningPopup(false)
            },
            onConfirm: {
                text: 'Yes, Delete',
                action: () => deleteWorkflow()
            } 
        })
    }

    const checkForAutoClear = (val) =>  val === "New Task..." && setOpenWorkflowModal2024({...workflow, todoName: ''})
    const changeTheOwner = (e) => setOpenWorkflowModal2024({...workflow, todoOwner: e})
    const changeTheSchool = (e) => setOpenWorkflowModal2024({...workflow, whichSchool: e})


    return (
        <div className='modal-area-fall-2023__wrapper' id='modal-area-fall-2023__wrapper'>
            {warningPopup && <WarningPopup warningPopup={warningPopup} />}
            <div className='modal-area-fall-2023' id='modal-area-fall-2023'>
                <div className='modal-area-fall-2023__header'>
                    <div className='modal-area-fall-2023__title-section'>
                        <div className='modal-area-fall-2023__title-section__text-wrapper'>
                            <div className='modal-area-fall-2023__title-section__column-badge-wrapper'>
                                <div className='modal-area-fall-2023__column-name'>{workflow.whichList.toUpperCase()}</div>
                                <TypeOfModalBadge2023 todoDescription={workflow.todoDescription} />
                            </div>
                                <input className='modal-area-fall-2023__task-name' value={workflow?.todoName} onClick={(e) => checkForAutoClear(e.target.value)} onChange={(e) => setOpenWorkflowModal2024({...workflow, todoName: e.target.value})} />
                        </div>
                        <BsThreeDotsVertical onClick={() => setOpenDropdown(!openDropdown)} color='#94A3B8' cursor={'pointer'} size={24} />
                        {openDropdown && <ModalDropdownMenuFall2023 setOpenDropdown={setOpenDropdown} menuItems={cardLayout[workflow.whichList].dropDownMenuOptions} />}
                    </div>
                    <div className='modal-area-fall-2023__selector-area-wrapper'>
                        {
                        cardLayout[workflow.whichList === 'student' ? 'scheduling' : workflow.whichList].adminAssignable && 
                            <div className='modal-area-fall-2023__selector__admin'>
                                <DropdownWithImage options={modalOwnerOptions} value={workflow.todoOwner} onChange={changeTheOwner} />
                            </div>
                        }
                        {
                        cardLayout[workflow.whichList === 'student' ? 'scheduling' : workflow.whichList].schoolAssignable &&
                            <div className='modal-area-fall-2023__selector__school'>
                                <DropdownWithImage options={modalSchoolOptions} value={workflow.whichSchool} onChange={changeTheSchool} />
                            </div>
                        }
                    </div>
                </div>
                {cardLayout[workflow.whichList === 'student' ? 'scheduling' : workflow.whichList].showCheckList ? 
                    <div className='modal-area-fall-2023__subtask__wrapper'>
                        {workflow?.todoSubtasks.map((subtask) => <Subtask2023 key={subtask.subtaskId} subtask={subtask} openModal2023={workflow} setOpenModal2023={setOpenWorkflowModal2024} />)}
                        {cardLayout[workflow.whichList === 'student' ? 'scheduling' : workflow.whichList].addTaskButton && <div className='modal-area-fall-2023__add-subtask' onClick={() => setOpenWorkflowModal2024({...workflow, todoSubtasks: [...workflow?.todoSubtasks, freshSubtask()]})}>+ Task</div>}
                    </div>
                    :
                    <div className='modal-area-fall-2023__message-instead-of-checklist'>{cardLayout[workflow.whichList === 'student' ? 'scheduling' : workflow.whichList].showMessageInsteadOfChecklist}</div>
                }
                <div className='modal-area-fall-2023__bottom-btn-area'>
                {cardLayout[workflow.whichList].redButton && <PrimaryButtonLarge text={cardLayout[workflow.whichList].redButton.label} color={{background: 'bg-red-500', text: 'text-white'}} action={() => cardLayout[workflow.whichList].redButton.onClick()} />}
                {cardLayout[workflow.whichList].redButton && <div className='modal-area-fall-2023__bottom-btn-area__spacer'></div>}
                {cardLayout[workflow.whichList].neutralButton && <PrimaryButtonLarge text={cardLayout[workflow.whichList].neutralButton.label} color={'bg-red-500'} textColor={'text-white'} action={() => cardLayout[workflow.whichList].neutralButton.onClick()} />}
                    {
                    cardLayout[workflow.whichList === 'student' ? 'scheduling' : workflow.whichList].moveForwardButton &&
                    <div className='modal-area-fall-2023__bottom-btn-area__btn-wrapper'>
                        {
                        cardLayout[workflow.whichList === 'student' ? 'scheduling' : workflow.whichList].moveForwardButton.label !== 'Complete Onboarding' ? 
                            <ButtonWithTrailingIconXLarge text={cardLayout[workflow.whichList === 'student' ? 'scheduling' : workflow.whichList].moveForwardButton.label} color={'bg-teal-500'} textColor={'text-white'} action={() => cardLayout[workflow.whichList === 'student' ? 'scheduling' : workflow.whichList].moveForwardButton.onClick()} />
                        :
                            <PrimaryButtonLarge text={cardLayout[workflow.whichList === 'student' ? 'scheduling' : workflow.whichList].moveForwardButton.label} color={{background: 'bg-teal-500', text: 'text-white'}} action={() => cardLayout[workflow.whichList === 'student' ? 'scheduling' : workflow.whichList].moveForwardButton.onClick()} />
                        }
                    </div>
                    }
                </div>
            </div>
        </div>
    )
}
export default ApplicationModalArea2024;